// Translations
import benchmarkTransaction from '../components/benchmark-transaction/translations/en'
import billingTransaction from '../components/billing-transaction/translations/en'
import finetuneTransaction from '../components/finetune-transaction/translations/en'
import modelTransaction from '../components/model-transaction/translations/en'
import pipelineTransaction from '../components/pipeline-transaction/translations/en'
import serviceTransaction from '../components/service-transaction/translations/en'
import transferTransaction from '../components/transfer-transaction/translations/en'

// Translation: Account > Billing > Transactions (English)
export default Object.freeze({
	components: { benchmarkTransaction, billingTransaction, finetuneTransaction, modelTransaction, pipelineTransaction, serviceTransaction, transferTransaction },
	fallback: {
		empty: 'No transactions found in the selected time range.',
		unavailable: 'Information is not available.'
	},
	title: 'Transaction history'
})
